/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable max-len */
/** @jsx jsx */
import React, { useMemo, useState, useCallback } from "react";
import { css, jsx } from "@emotion/core";
import { Column } from "react-table";
import DataTable from "components/organismos/DataTable/DataTable";
import IconLabelButton from "components/molecules/IconLabelButton";
import BlockUI from 'components/molecules/BlockUi';
import ExecutiveDomain from "domain/master/labor/executive";
import { deleteById, downloadCSV } from "api/executive";
import ToastModal from "components/organismos/ToastModal";
import useExecutiveList from "components/organismos/Executive/ExecutiveIndexPage/hooks";
import useToastNotification from "hooks/useToastNotification";
import FormContents from "components/atoms/Form/FormContents";
import {SubActionButton } from "components/atoms/Button";
import FormSubmitArea from "components/atoms/Form/FormSubmitArea";
import { useHistory } from "react-router-dom";
import { isTablet, isSafari } from "react-device-detect";
import Modal from "components/molecules/Modal";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import FormHeader from "components/templates/FormHeader";
import FormPadding from "components/atoms/Form/FormPadding";
import FlexBox from "components/atoms/FlexBox";

const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
  customStyle: css(
    {
      display: "flex",
      marginLeft: "0",
      paddingTop:'16px',
      justifyContent: 
        (isSafari && isTablet) || isIpad ? "flex-start" : "flex-end",
      paddingRight: (isSafari && isTablet) || isIpad ? "10px" : "15px",
      marginBottom: (isSafari && isTablet) || isIpad ? "0px" : "-16px",
    },
    css`
      button {
        width: auto;
        margin-left: 12px;
      }
      button:hover {
        background: transparent;
      }
      button svg {
        width: 20px !important;
        height: 20px !important;
      }
    `
  ),
};
const ExecutiveIndexLayoutPage: React.FC = () => {
  const history = useHistory();
  const { executiveList, setExecutiveList, isLoading, setIsLoading } = useExecutiveList();
  const [valueExecutiveId, setValue] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [toastMessage] = useState("");
  const [toastModalOpen, setToastModalOpen] = useState(false);
  const { successNotification, errorNotification } = useToastNotification();

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const openConfirmModal = useCallback((item: ExecutiveDomain) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setValue(item.executiveId);
    setConfirmModalOpen(true);
  }, []);

  const downloadFileCSV = useCallback(() => {
    const companyCode = sessionStorage.getItem("loginUser.companyCode") || "";
    downloadCSV(companyCode);
  }, []);

  const deleteExecutiveById = useCallback(() => {
    setIsLoading(true);
    if (executiveList) {
      deleteById(valueExecutiveId)
        .then((response: any) => {
          setExecutiveList(
            executiveList.filter(
              (executive) => executive.executiveId !== valueExecutiveId
            )
          );
          setConfirmModalOpen(false);
          successNotification("削除しました。");
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setConfirmModalOpen(false);
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            let msgError = "";
            error.response.data.errors.map(
              (item: { defaultMessage: string }) => {
                msgError += `${item.defaultMessage} </br>`;
                return msgError;
              }
            );
            errorNotification(msgError);
          } else {
            errorNotification("サーバー側でエラーが発生しました。");
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueExecutiveId, executiveList]);

  const columns: Array<Column<ExecutiveDomain>> = useMemo(
    () => [
      {
        Header: () => null,
        accessor: "action",
        id: "actionButton",
        disableSortBy: true,
        Cell: (cell: {
          row: { isExpanded: boolean; original: ExecutiveDomain };
          data: Array<ExecutiveDomain>;
        }) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <FlexBox>
            <FlexBoxItem width='36px' marginLeft="5px">
              <SubActionButton
                action={0}
                text="編集" 
                onClick={() => {
                  history.push(
                    `/executive/edit/${cell.row.original.companyCode}/${cell.row.original.executiveId}`
                  );
                }}
              />
            </FlexBoxItem>
            <FlexBoxItem margin="0 5px" width='36px'>
              <SubActionButton 
                action={1}
                onClick={() => {
                  openConfirmModal(cell.row.original);
                }}
                text="削除">
              </SubActionButton>
            </FlexBoxItem>  
            </FlexBox>
          </div>
        ),
      },
      {
        Header: "役職コード",
        accessor: "executiveCode",
      },
      {
        Header: "役職名",
        accessor: "executiveName",
      },
    ],
    [openConfirmModal, history]
  );

  const sortBy = React.useMemo(
    () => [
      {
        id: "executiveCode",
        desc: false,
      },
    ],
    []
  );
  return (
    <BlockUI blocking={isLoading}>
    <FormHeader title="役職マスタ" />
    <FormContents customStyle={css({marginTop:'60px'})} >
      <FormSubmitArea customStyle={styles.customStyle}>
        <IconLabelButton
          onClick={() => history.push("/executive/add")}
          iconType="addCircle"
          text="追加"
        />
        <IconLabelButton
          onClick={() => history.push("/executive/import")}
          iconType="addCircle"
          text="インポート"
        />
        <IconLabelButton
          onClick={downloadFileCSV}
          iconType="download"
          text="CSVダウンロード"
        />
      </FormSubmitArea>  

      <div
        css={css`
          table th:nth-of-type(1) {
            width: 84px;
          }
        `}
      >
        <div 
          className="table-padding table-bordered" 
          style={{ whiteSpace: "nowrap", overflowX: 'auto', paddingBottom: '15px' }}
        >
          <DataTable
            classNameParrant="border-left-right"
            className="table-no-border-left-right"
            columns={columns}
            data={executiveList}
            isGlobalFilter={true}
            sortBy={sortBy}
            minWidth="100%"
          />
        </div>
      </div>
      {/* modal delete */}
      <Modal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        title="役職マスタを削除"
        submitText="削除する"
        note="役職マスタを削除します。よろしいですか？"
        onSubmit={deleteExecutiveById}
        typeSubmit="reject"
      >
        <div style={{ height: "40px" }}></div>
      </Modal>

      {/* confirm modal */}
      {/* <ConfirmModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        title="確認メッセージ"
        content="削除します。よろしいですか？"
        submitText="削除"
        onSubmit={deleteExecutiveById}
        items={[]}
      /> */}

      {/* ToastModal */}
      <ToastModal
        open={toastModalOpen}
        closeHandler={() => setToastModalOpen(false)}
        title={toastMessage}
      />
    </FormContents>
    </BlockUI> 
  );
};

export default ExecutiveIndexLayoutPage;
